<form>
  <div class="modal-header">
    <h4 class="modal-title">
      {{'project_settings.title' | translate}}
    </h4>
  </div>
  <div class="modal-body pt-0">
      <ng-scrollbar #scroll [visibility]="'hover'" heightOffset="240" style="margin: 0.5rem;">
        <app-project-settings #projectSettings [isCollapsed]="isCollapsed"
          [projectGroup]="projectGroup"
          [saveEvent]="finish"
          (saved)="close(true)"
          [isArticleProjectGroup]="isArticleProjectGroup"
          [isCanceling]="isCanceling"></app-project-settings>
      </ng-scrollbar>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-cancel" (click)="isCanceling = true; close(false)">
      {{'global.label.cancel' | translate}}
    </button>
    <button type="button" data-testid="project-settings-submit" class="btn btn-primary btn-forward" (click)="onConfirm()">
      {{'global.label.save' | translate}}
    </button>
  </div>
</form>
